var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: {
        effect: "dark",
        "hide-after": 1000,
        content: _vm.tip,
        placement: "top-start",
        disabled: !_vm.tip || _vm.tip.length === 0,
      },
    },
    [
      _c(
        "span",
        { staticClass: "u8-icon-btn", on: { click: _vm.onIconClick } },
        [
          _c("i", { staticClass: "iconfont", class: _vm.icon }),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }